import React from "react";
import reactStringReplace from "react-string-replace";
import { Medication } from "../../../../messages/MedicationProfile";
import SearchModalResult from "../../../SearchModal/SearchModalResult/SearchModalResult";

interface Props {
  medication: Medication;
  marked: string;
  onClick: (medication: Medication) => void;
}

const SearchMedicationResult = ({ medication, marked, onClick }: Props) => {
  const metadata = [medication.dose, medication.brandName].filter(Boolean);

  const markedText = React.useMemo(
    () =>
      reactStringReplace(medication.displayName, marked, (match, i) => (
        <mark key={i}>{match}</mark>
      )),
    [medication.displayName, marked]
  );

  return (
    <SearchModalResult label={markedText} metadata={metadata} onClick={() => onClick(medication)} />
  );
};

export default React.memo(SearchMedicationResult);
